import { api } from '@/api/api'

import type {
  Skid,
  SkidPaginatedResponse,
  SkidPayload,
  SkidUpdatePayload,
  SkidsQueryParams
} from './skids-types'

export const skidsService = {
  get: async (params: SkidsQueryParams = {}) => {
    const { data } = await api.get<SkidPaginatedResponse>('/skids/', { params })
    return data
  },

  getById: async (id: number) => {
    const { data } = await api.get<Skid>(`/skids/${id}/`)
    return data
  },

  add: async (payload: SkidPayload) => {
    const { data } = await api.post<Skid>('/skids/', payload)
    return data
  },

  update: async (id: number, payload: SkidUpdatePayload) => {
    const { data } = await api.patch<Skid>(`/skids/${id}/`, payload)
    return data
  },

  delete: async (id: number) => {
    const { data } = await api.delete(`/skids/${id}/`)
    return data
  },

  /** Outside Rack / bulk clear: remove all LHBS bundles from this skid. */
  resetLhbs: async (id: number) => {
    const { data } = await api.post<Skid>(`/skids/${id}/reset-lhbs/`)
    return data
  }
}
